export default __webpack_public_path__ + "images/moderation-empty-icon.643f01f91d907465e1955a32ccaece93.svg";